import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PaymentRemoveFromInvoiceParams = {
  paymentId: string;
  invoiceId: string;
};

export const paymentRemoveFromInvoiceAtom = createMutationAtomFactory(
  'finance.paymentRemoveFromInvoice',
  (params: PaymentRemoveFromInvoiceParams) => ({
    financePaymentRemoveFromInvoice: {
      __args: {
        paymentId: params.paymentId,
        invoiceId: params.invoiceId,
      },
      id: true,
      documentNumber: true,
      status: true,
      invoices: {
        invoice: {
          id: true,
          documentNumber: true,
        },
        appliedAmount: {
          amount: true,
          currencyCode: true,
        },
        appliedAt: true,
      },
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
